import { urlPath } from "..";
import { uniqueNamesGenerator, adjectives, colors } from 'unique-names-generator';
import { gameDataObject1, gameDataObject4 } from "./specificGames/savedGames";

export class Random {
    private seed: number;
    private stringSeed: string | null;
    private startingSeed: number;
    private m: number = 0x80000000; // 2^31
    private a: number = 1103515245;
    private c: number = 12345;
    public savedGame: boolean = false;
    public savedGameFile: any | null;

    constructor(seedInput: string | number | null) {
        this.stringSeed = null;

        if (seedInput == null) {

            const randomName = Random.generateSeedName();
            this.seed = 1 / this.hashString(randomName) % this.m;
            
            this.stringSeed = randomName;
            console.log("result =  " + randomName);
            
        } else if (typeof seedInput === 'string') {

            seedInput = seedInput.toLocaleLowerCase();

            if (seedInput == 'dice-tower-1') {

                console.log('loading Dice Tower save!');

                this.stringSeed = "dice-tower-1";
                
                const savedSeed = gameDataObject4.randomSeed;

                this.savedGame = true;
                this.savedGameFile = gameDataObject4;

                if (typeof savedSeed === 'number') {
                    this.seed = savedSeed % this.m;
                    
                } else {
                    this.seed = 27 % this.m;
                }
                

            } else {
                // OLD SEEDS DIDN'T USE THIS
                this.seed = 1 / this.hashString(seedInput) % this.m;
                this.stringSeed = seedInput;
                console.log("result =  " + this.seed);
            }
            
        } else {
            this.seed = seedInput % this.m;
        }

        this.startingSeed = this.seed;
    
        console.log('seed input: ' + seedInput);
    }

    public static generateSeedName(): string {
        return uniqueNamesGenerator({
            dictionaries: [adjectives, colors],
            separator: '-',
            length: 2
        });
    }

    private next(): number {
        this.seed = (this.a * this.seed + this.c) % this.m;
        return this.seed / this.m;
    }

    public random(): number {
        return this.next();
    }

    private hashString(str: string): number {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char; // hash * 31 + char, assuming 31 can be replaced with a bit-shift and subtract
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }

    public getCurrentSeed(): string {
        if (this.stringSeed != null) {
            return this.stringSeed;
        } else {
            return this.seed.toString();
        }
        
    }

    public restartGame() {
        this.seed = this.startingSeed;
    }

    public advance(steps: number): void {
        for (let index = 0; index < steps; index++) {
            this.next();
        }
    }
}
